import ascommon from "./ascommon";
import $ from "jquery";
import "bootstrap";
import moment from "moment";

export class SessionManager {
    private $logoutCounterDialog: JQuery;
    private $autoLogoutCounter: JQuery;
    private $autoLogoutDiv: JQuery;
    private $logoutCounter: JQuery;
    private $logoutText: JQuery;
    private $asMenu: JQuery;

    private logoutTime: number;
    private logoutSeconds: number;
    private logoutCounter: number;
    private logoutTimer: NodeJS.Timeout;
    private sessionTimer: NodeJS.Timeout; // pings home to the server to maintain session state
    private logoutCounterVisible: boolean;
    private userTouched: boolean;
    private userTouched1: boolean;
    private asMenuShown: boolean;
    private currentPage: string;
    private visitWorker: Worker;

    constructor() {
        const that = this;

        this.currentPage = self.location.pathname.toLowerCase().substring(1);

        if (!self.MainWorklist) {
            this.visitWorker = new Worker(window.VisitWorkerPath, { type: "module" });
        }

        // Activity listeners
        $(document).on('mousedown', function (event: JQuery.MouseDownEvent) {
            // Stop the log dump process now that the user is reengaging with the app
            if (that.visitWorker) {
                that.visitWorker.postMessage({ type: "StopSendingLogs" });
            }

            if (self.parent && self.parent.name === 'ivWindow' && event.target && event.target.className === 'focus') {
                // case 15555
            } else {
                if (self.SendCommandToLauncher) {
                    self.SendCommandToLauncher('runMethodOnMain', 'sessionManager.userTouchedFromLauncher', 'document.mousedown');
                }

                if (event.target) {
                    ascommon.log("document.mousedown on element " + event.target.id);
                } else {
                    ascommon.log("document.mousedown (no event.target)");
                }
            }

            if (self.opener && self.name !== 'mainWindow') {
                self.opener.sessionManager.userTouched = true;
            } else {
                that.userTouched = true;
                that.userTouched1 = true;
            }

            if (document.activeElement && ($(document.activeElement).hasClass("trumbowyg-editor") || $(document.activeElement).hasClass("fr-view"))) {
                var sel = self.getSelection();
                if (sel.getRangeAt && sel.rangeCount) {
                    self.currentSelection = sel.getRangeAt(0);
                }
                else {
                    self.currentSelection = null;
                }
            }
        });

        $(document).on('keydown', function (event: JQuery.KeyDownEvent) {
            // Stop the log dump process now that the user is reengaging with the app
            if (that.visitWorker) {
                that.visitWorker.postMessage({ type: "StopSendingLogs" });
            }

            if (self.SendCommandToLauncher) {
                self.SendCommandToLauncher('runMethodOnMain', 'sessionManager.userTouchedFromLauncher', 'document.keydown');
            }
            var elm = event.target ? event.target.id : " no event target";
            ascommon.log("document.keydown on element: " + elm);
            if (self.opener && self.name !== 'mainWindow') {
                self.opener.sessionManager.userTouched = true;
            } else {
                that.userTouched = true;
                that.userTouched1 = true;
            }
        });

        // login page only needs activity tracking and upon reaching the login page start dumping logs immediately
        if (this.currentPage === Pages.login) {
            this.visitWorker.postMessage({ type: "SendLogs" });
            this.unregisterServices();
            return;
        }

        // Session listeners
        $(document).ready(function() {
            // Had to use jQuery here instead of $ because modal is not binding correctly to $.
            // I think this is because we have multiple jQuery libraries referenced at once.
            that.$logoutCounterDialog = jQuery("#logoutCounterDialog");
            that.$autoLogoutCounter = jQuery("#autoLogoutCounter");
            that.$autoLogoutDiv = jQuery("#autoLogoutDiv");
            that.$logoutCounter = jQuery("#logoutCounter");
            that.$logoutText = jQuery("#logoutText");
            that.$asMenu = jQuery('#asMenu');

            if (!that.logoutTime) {
                that.logoutTime = Date.now() + 20 * 60 * 1000; //20 min
            }

            that.$logoutCounterDialog.on("show.bs.modal", function () {
                try {
                    that.logoutCounterVisible = true;
                    // case 16048, 16069
                    if ($("#reportPreviewDialog").hasClass("in")) $("#reportPreviewDialog #reportPreview").hide();
                    if (self.spellcheckInProgress) $(".dxwsc-main").hide();
                    if (that.$asMenu.is(':visible')) {
                        that.$asMenu.hide();
                    }
                }
                catch (err) {
                    ascommon.log("logoutCounterDialog.show() - " + err.message);
                }
            });

            that.$logoutCounterDialog.on("hide.bs.modal", function () {
                try {
                    that.logoutCounterVisible = false;
                    // case 16048, 16069
                    if ($("#reportPreviewDialog").hasClass("in")) $("#reportPreviewDialog #reportPreview").show();
                    if (self.spellcheckInProgress) $(".dxwsc-main").show();
                    if (that.$asMenu.is(':visible')) {
                        that.$asMenu.show();
                    }
                }
                catch (err) {
                    ascommon.log("logoutCounterDialog.hide() - " + err.message);
                }
            });

            that.$logoutCounterDialog.on('mousedown', function () {
                that.HideAutologoutCounter();
            });

            that.$logoutCounterDialog.on('keydown', function () {
                that.HideAutologoutCounter();
            });

            that.unregisterServices();
        });

        if (!that.sessionTimer) {
            that.sessionTimer = setInterval(() => that.KeepSessionAlive(), 60000); // 1 min
        }
    }

    public SetAutoLogout(seconds: number) {
        let that = this;

        this.logoutSeconds = seconds;
        this.logoutTime = Date.now() + seconds * 1000;

        if (this.logoutTime) {
            this.logoutCounter = 0;
            if (this.logoutTimer) clearInterval(this.logoutTimer);
            this.logoutTimer = setInterval(() => that.checkUserActivity(), 10000); // 10 sec
            ascommon.log("AutoLogout: Set logoutTimer for " + seconds + " seconds");
        }
    }

    public logOut(source: string) {
        self.showBusyIndicator();
        this.ClearTimers();
        this.abortAllRequests();
        $(document).ajaxError(undefined);

        // Pre-logout actions
        try {
            if (self.activeUser && self.isHiddenVisitShown) {
                if (self.activeSection && self.canLeaveSection(self.activeSection)) {
                    let $template = jQuery('#' + self.templateName);
                    if (self.focusedFieldId !== undefined && self.focusedFieldId !== null && self.focusedFieldId !== '') {
                        self.MDicBlurFunction($template.find('#' + self.focusedFieldId).get(0));
                    }
                    const scope = $template.scope() as IEditModeControllerScope;
                    if (scope && scope.selectedGrid)
                    {
                        scope.resetGrid();
                    }

                    if (validateVisit())
                        self.SaveTemplate(self.templateId);
                }

                if (self.isNewDemographics && !self.ValidatePatientName()) {
                    self.abortPatientInBackground();
                }
            }
        }
        catch (ex) {
            ascommon.log(`Pre-logout actions failed: ${ex.message}`);
        }

        ascommon.log("Starting Logout attempt: User " + (self.activeUser ? self.activeUser.UserID : "Anonymous") + ", Source " + source + ", Time " + moment().format('MM/DD/YYYY'));

        try {
            self.clearTemplateStorage();
            this.clearWindowsOnLogout();
            WorklistTimer.HideWorklist();
            $('#asMenu').css('display', 'none');

            // clear the authorization token header
            if (self.sessionStorage) {
                self.sessionStorage.setItem('authorization_token', null);

                $.ajaxSetup({
                    headers: {
                        'Authorization': null
                    }
                });

                if (MainWorklist && MainWorklist.visitWorker) {
                    MainWorklist.visitWorker.postMessage({
                        type: "SetTokens",
                        antiForgeryToken: null,
                        authorizationToken: null
                    });
                }
            }

            self.SendCommandToLauncher('logOut', '');

            self.activeUser = null;
            ascommon.ajax(
                '/Account/LogOut',
                { caller: source },
                null,
                null,
                "POST",
                false
            );

            self.SendCommandToLauncher("shutdown");
            if (source === "serverErrorDialog") {
                self.SendCommandToLauncher('closeLauncher', '');
            }
        }
        catch (ex) {
            ascommon.log(`Logout attempt failed: ${ex.message}`);
        }
        finally {
            self.location.href = "/login" + self.location.search;
        }
    }

    public abortAllRequests() {
        self.ascommon.log("abortAllRequests: requests number in pool: " + self.xhrPool.length);

        $.each(self.xhrPool, function(idx, jqXHR) {
            jqXHR.abort();
            self.ascommon.log("Request aborted: " + jqXHR.responseURL);
        });
    }

    public clearWindowsOnLogout() {
        ascommon.log('clearWindowsOnLogout: call to clearWindowsOnLogout');

        self.sessionStorage.setItem("splitterLeftPanelWidth", '');
        var isIVOpened = self.sessionStorage.getItem("isIVOpened");
        if (isIVOpened === "true") {
            var iv = self.getImageViewerWindow();
            iv.close();
        }
    }

    public ClearTimers() {
        if (this.sessionTimer) clearInterval(this.sessionTimer);
        if (this.logoutTimer) clearInterval(this.logoutTimer);
    }

    public userTouchedFromLauncher() {
        this.userTouched = true;
        this.userTouched1 = true;
    }

    public HideAutologoutCounter() {
        self.SendCommandToLauncher('runMethodOnMain', 'sessionManager.HideAutologoutCounterOnMaster');

        if (self.opener && self.name !== 'mainWindow') {
            self.opener.sessionManager.HideAutologoutCounterOnMaster();
        } else {
            clearInterval(this.logoutTimer);
            ascommon.log('HideAutologoutCounter: cleared LogoutTimer');
            this.$logoutCounterDialog.modal("hide");
            this.HideAutologoutChildrenCounter();
            this.SetAutoLogout(self.activeUser.Settings.AutoLogoffInterval * 60);
        }
    }

    private KeepSessionAlive() {
        ascommon.ajax("/Account/KeepSessionAlive", null, null);
    }

    /*
     * The intention of this function is to make sure workers don't get stuck with cached code for too long.
     * The unregistered services will still function until the user closes the tabs it is registered to.
     * Workers should be re-instantiated every time a page that needs them loads.
     * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API/Using_Service_Workers#updating_your_service_worker
     */
    private unregisterServices() {
        navigator
            .serviceWorker
            .getRegistration()
            .then((serviceWorker) => {
                if (serviceWorker) {
                    serviceWorker.unregister();
                }
            })
            .catch((error) => {
                console.error("Failed to unregister serviceworker: ", error);
            });
    }

    private checkUserActivity() {
        let that = this;

        if (that.userTouched) {
            that.logoutCounter = 0;
            that.logoutTime = Date.now() + that.logoutSeconds * 1000;
            that.userTouched = false;
        } else {
            that.logoutCounter++;
        }

        // Autosave after first min on inactivity
        if (that.logoutCounter === 6) {
            if (typeof self.SaveTemplate === "function") {
                ascommon.log("Initiating visit save due to user inactivity")
                if (self.isHiddenVisitShown) {
                    var focusedElement = $(":focus");
                    if (focusedElement.length > 0) {
                        focusedElement.trigger("blur");
                    }
                }
                self.SaveTemplate(self.templateId);
            }

            // Start sending logs while the user is inactive
            if (that.visitWorker) {
                that.visitWorker.postMessage({ type: "SendLogs" });
            }
        }

        if ((that.logoutTime - 180 * 1000) < Date.now()) { //if less than 3 min left
            clearInterval(that.logoutTimer);
            that.logoutCounter = 181; // 3 min
            that.updateLogoutCounter(that.logoutTime);
            that.prepareCounter();
            that.showCounter();
            that.logoutTimer = setInterval(() => that.updateLogoutCounter(that.logoutTime), 1000);

            if (!self.opener || self.name === 'mainWindow') {
                self.SendCommandToLauncher('runMethodOnIV', 'sessionManager.prepareCounter');
                self.SendCommandToLauncher('runMethodOnIV', 'sessionManager.showCounter');

                var isIVOpened = sessionStorage.getItem("isIVOpened");
                if (isIVOpened === "true") {
                    var iv = self.getImageViewerWindow();
                    if (iv && !iv.closed) {
                        iv.sessionManager.prepareCounter();
                        iv.sessionManager.showCounter();
                    }
                }
            }
        }
    }

    private showCounter() {
        this.$logoutCounterDialog.modal({ keyboard: false });
    }

    private prepareCounter() {
        this.$autoLogoutCounter.closest(".modal-body").css("height", "100%");
        this.$autoLogoutCounter.css("left", "50%");
        this.$autoLogoutCounter.css("margin-left", "-200px");
        this.$autoLogoutCounter.css("top", "50%");
        this.$autoLogoutCounter.css("margin-top", "-200px");

        this.$autoLogoutDiv.css("margin-top", 180);
        this.$logoutText.text(self.StringResources.Logout_LoggingOutIn);
    }

    private HideAutologoutCounterOnMaster() {
        clearInterval(this.logoutTimer);
        ascommon.log('HideAutologoutCounterOnMaster: cleared LogoutTimer');
        this.HideCounterOnCurrentPage();
        this.HideAutologoutChildrenCounter();
        this.SetAutoLogout(self.activeUser.Settings.AutoLogoffInterval * 60);
    }

    private HideCounterOnCurrentPage() {
        this.$logoutCounterDialog.modal("hide");
    }

    private HideAutologoutChildrenCounter() {
        if (!self.opener || self.name === 'mainWindow') {
            self.SendCommandToLauncher('runMethodOnIV', 'sessionManager.HideCounterOnCurrentPage');

            var isIVOpened = self.sessionStorage.getItem("isIVOpened");
            if (isIVOpened === "true") {
                var iv = self.getImageViewerWindow();
                if (iv && !iv.closed) {
                    iv.sessionManager.HideCounterOnCurrentPage();
                }
            }
        }
    }

    private updateLogoutCounter(logoutTime: number) {
        const that = this;

        that.logoutCounter--;
        var now = Date.now();

        if (now < logoutTime) {
            const milliseconds = logoutTime - now;
            const min = Math.floor(milliseconds / 60000);
            const sec = Math.floor((milliseconds % 60000) / 1000);
            const timeFormatted = min + ":" + (sec < 10 ? "0" + sec : sec);

            that.$logoutCounter.text(timeFormatted);

            if ((!self.opener || self.name === 'mainWindow') && self.name !== "ivWindow") {
                ascommon.log("SessionManager: windowname - " + self.name);
                self.SendCommandToLauncher('updateLogoutCounter', logoutTime.toString());
                var isIVOpened = self.sessionStorage.getItem("isIVOpened");
                if (isIVOpened === "true") {
                    var iv = self.getImageViewerWindow();
                    if (iv && !iv.closed) {
                        iv.sessionManager.$logoutCounter.text(timeFormatted);
                    }
                }
            }
        }
        else {
            clearInterval(that.logoutTimer);
            ascommon.log('updateLogoutCounter: cleared LogoutTimer - going to logout!');
            that.$logoutText.text(self.StringResources.Logout_LoggingOut);
            that.$logoutCounter.text("");

            that.asMenuShown = false;
            that.HideAutologoutChildrenCounter();
            jQuery(".modal.in").modal("hide");

            that.logOut("AutoLogOff");
        }
    }
}

enum Pages {
    login ="login",
    worklistview = "worklistview",
    imageviewer = "imageviewer"
}

export default SessionManager;
// for main thread this is window, for workers this is the WorkerGlobalScope
self.SessionManager = SessionManager;

self.sessionManager = new SessionManager(); // the instance for the window
